<div class="view-header"></div>

@if (
  breakpointService.deviceType() !== 'desktop' && (authStore.isAuthenticated() || isBlogContext())
) {
  <button
    type="button"
    class="app-container__mobile-backdrop"
    [class.app-container__mobile-backdrop--open]="sidebarUiStore.isOpen()"
    aria-label="Закрыть меню"
    (click)="sidebarUiStore.close()"
  ></button>

  <aside
    class="app-container__mobile-sidebar"
    [class.app-container__mobile-sidebar--open]="sidebarUiStore.isOpen()"
    [attr.aria-hidden]="!sidebarUiStore.isOpen()"
  >
    @if (isBlogContext()) {
      <app-blog-sidebar-nav />
    } @else {
      <app-sidebar-nav />
    }
  </aside>
}

<router-outlet></router-outlet>

<app-footer></app-footer>

<div class="view-snackbar"></div>
